import { css, styled } from 'styled-components';
import { CustomThemeToken } from '@/theme/theme.utils';
import { breakpoints } from '@/utils/util-breakpoints';

export const StyledStageHeader = styled.div<{ theme: { token: CustomThemeToken }, $isDisabled: boolean }>`
    display: flex;
    align-items: start;
    justify-content: space-between;
    scroll-margin-top: ${({ theme }) => theme.token.marginXXL}px;
    ${({ $isDisabled }) => $isDisabled && css`
        opacity: 0.5;
        pointer-events: none;
        filter: grayscale(100%);
    `}
    .stage-name-and-block-events-container {
        display: flex;
        flex-direction: column;
        gap: ${({ theme }) => theme.token.padding}px;
    }
    .block-events-container {
        font-size: ${({ theme }) => theme.token.fontSize}px;
        line-height: ${({ theme }) => theme.token.marginXXL}px;
        display: flex;
        align-items: center;
        gap: ${({ theme }) => theme.token.padding}px;
        .block-events-section {
            display: flex;
            align-items: end;
            gap: ${({ theme: { token } }) => token.marginSM}px;
            .block-events {
                max-height: 100px;
                overflow-y: auto;
                display: flex;
                flex-direction: column;
                max-width: 450px;
                .block-event {
                    display: flex;
                    white-space: nowrap;
                    gap: ${({ theme: { token } }) => token.marginXS}px;
                    .block-event-date {
                        color: ${({ theme: { token } }) => token.colorTextDescription};
                    }
                    .block-event-date-separator {
                        @media (max-width: ${breakpoints.lg}px) {
                            display: none;
                        }
                    }
                    .block-event-name {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        color: ${({ theme: { token } }) => token.colorText};
                    }
                    .unblock-reason {
                        color: ${({ theme: { token } }) => token.colorPrimary};
                        cursor: pointer;
                    }
                    @media (max-width: ${breakpoints.lg}px) {
                        flex-direction: column;
                        gap: ${({ theme: { token } }) => token.marginSM}px;
                    }
                }
                @media (max-width: ${breakpoints.lg}px) {
                    max-width: 220px;
                    max-height: 200px;
                    gap: ${({ theme: { token } }) => token.marginLG}px;
                }
            }
            .add-block-event-button {
                color: ${({ theme: { token } }) => token.colorPrimary} !important;
                height: auto;
            }
        }
        @media (max-width: ${breakpoints.lg}px) {
            line-height: ${({ theme }) => theme.token.margin}px;
        }
    }
    .stage-status-tag {
        margin-right: ${({ theme }) => theme.token.margin}px;
        transform: scale(1.1);
        .ant-tag-blue {
            color: ${({ theme }) => theme.token.colorPrimaryText};
            background: ${({ theme }) => theme.token.colorPrimaryBg};
            border-color: ${({ theme }) => theme.token.colorPrimaryBorder};
        }
    }
    @media (max-width: ${breakpoints.sm}px) {
        flex-direction: column-reverse;
        gap: ${({ theme }) => theme.token.padding}px;
    }
`;